import React from "react";
import { authRoles } from "../../auth/authRoles";

const ViewApplicationsSingleRoutes = [

  {
    path: "/view_application_single",
    component: React.lazy(() => import("./AllViewApplicationsSingle")),
    auth: authRoles.dashboard
  },
  
];

export default ViewApplicationsSingleRoutes;
